// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root___q9a-","content":"LayoutSettings_content__uEtoa"};